import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
	BreakpointObserver,
	Breakpoints,
	BreakpointState,
} from '@angular/cdk/layout';

@Injectable({
	providedIn: 'root',
})
export class ScreenSizeService {
	private readonly _isSmall = new BehaviorSubject<boolean>(false);
	isSmall$ = this._isSmall.asObservable();

	constructor(public breakpointObserver: BreakpointObserver) {
		this.breakpointObserver
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.subscribe((state: BreakpointState) => {
				if (state.matches) {
					this._isSmall.next(true);
				}
			});

		this.breakpointObserver
			.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
			.subscribe((state: BreakpointState) => {
				if (state.matches) {
					this._isSmall.next(false);
				}
			});
	}

	get isSmall() {
		return this._isSmall;
	}
}
